import { Controller } from "@hotwired/stimulus"

// "Plan the drive" sheet (Trips step 2). Opens a native <dialog> instead of
// following the link (the link is the no-JS fallback page). "My location"
// asks the browser once and only fills the form; nothing is stored until
// the person saves the trip.
export default class extends Controller {
  static targets = ["dialog", "form", "lat", "lng", "fromText", "status", "tripId", "locateOption"]

  connect() {
    if (this.hasLocateOptionTarget && !("geolocation" in navigator)) this.locateOptionTarget.hidden = true
  }

  open(event) {
    if (!this.hasDialogTarget || typeof this.dialogTarget.showModal !== "function") return
    event.preventDefault()
    this.dialogTarget.showModal()
    const first = this.dialogTarget.querySelector("input[name=from_location]")
    if (first) first.focus()
  }

  close() {
    if (this.hasDialogTarget) this.dialogTarget.close()
  }

  backdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  fromChanged() {
    this.latTarget.value = ""
    this.lngTarget.value = ""
    this.statusTarget.textContent = ""
  }

  locate() {
    if (!("geolocation" in navigator)) return
    this.statusTarget.textContent = "Finding you…"
    navigator.geolocation.getCurrentPosition(
      (position) => {
        this.latTarget.value = position.coords.latitude.toFixed(4)
        this.lngTarget.value = position.coords.longitude.toFixed(4)
        this.statusTarget.textContent = "Using your location as the start."
      },
      () => {
        this.statusTarget.textContent = "Location not available. Type a city instead."
        const city = this.element.querySelector("input[name=from_mode][value=city]")
        if (city) city.checked = true
        this.fromTextTarget.focus()
      },
      { enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 }
    )
  }

  pickTrip(event) {
    this.tripIdTarget.value = event.currentTarget.dataset.tripId || ""
  }
}
